<template>
	<div id="app">
		<el-container v-if="onLine && (!isMobile || isMobileAllowedRoute)">
			<el-aside v-if="$route.meta.requiresAuth && !isMobile && $route.name !== 'payment' && $route.name !== 'documentation' && $route.name !== 'docs'" width="80px">
				<navSideBar />
			</el-aside>
			<router-view key="router"></router-view>
		</el-container>
		<noConnection v-if="!onLine" />
		<isMobile v-if="isMobile && onLine && !isMobileAllowedRoute" />
	</div>
</template>

<script>
const isMobile = () => import("./pages/isMobile_page.vue");
const noConnection = () => import("./pages/noConnection_page.vue");
const navSideBar = () => import("./components/navSideBar.vue");
export default {
	name: "App",
	components: {
		isMobile,
		noConnection,
		navSideBar,
	},
	data() {
		return {
			onLine: navigator.onLine,
			isMobile: false,
		};
	},
	computed: {
		isMobileAllowedRoute() {
			if (!this.$route) return false;
			return this.$route.name === "home" || this.$route.name === "payment" || this.$route.name === "documentation" || this.$route.name === "docs";
		}
	},
	watch: {
		$route(to) {
			document.title = to.meta.title || "Centiloquy";
		},
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleResize);
		window.removeEventListener("online", this.updateConnectionStatus);
		window.removeEventListener("offline", this.updateConnectionStatus);
	},
	mounted() {
		this.handleResize();
		window.addEventListener("resize", this.handleResize);
		window.addEventListener("online", this.updateConnectionStatus);
		window.addEventListener("offline", this.updateConnectionStatus);
		// Load Google Fonts non-blocking
		const fontLink = document.createElement('link');
		fontLink.rel = 'stylesheet';
		fontLink.href = 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&display=swap';
		fontLink.media = 'print';
		fontLink.onload = function() { this.media = 'all'; };
		document.head.appendChild(fontLink);
	},
	methods: {
		updateConnectionStatus() {
			this.onLine = navigator.onLine;
		},
		handleResize() {
			if (document.documentElement.clientWidth < 1250) {
				this.isMobile = true;
			} else if (document.documentElement.clientWidth > 1250) {
				this.isMobile = false;
			}
		},
	},
};
</script>

<style>
/* Google Fonts loaded non-blocking via mounted() hook */

html {
	scroll-behavior: smooth;
}
body {
	margin: 0px;
	overflow: hidden;
	font-family: "Open Sans", sans-serif !important;
}

input {
	line-height: normal !important;
}

#app {
	font-family: "Open Sans", sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	height: 100vh;
}

label {
	font-weight: bold;
	color: black !important;
}

.el-form-item {
	margin-bottom: 10px !important;
}

.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
	display: none;
}

.el-form-item__error {
	right: 0;
	left: unset !important;
}

.emailVerify {
	margin-bottom: 20px;
	display: block !important;
	font-size: 40px;
	text-align: center;
}

.el-message-box {
	color: black !important;
	font-family: "Open Sans", sans-serif !important;
}

.el-carousel__container {
	height: 100% !important;
}

.el-carousel__button {
	background-color: #210f3c !important;
}

.el-tabs__nav-wrap::after {
	height: 1px !important;
	background-color: #e9e9eb !important;
}

.el-empty__description p {
	color: #2c3e50 !important;
	font-weight: bold;
	font-size: 20px !important;
}

.el-drawer__header {
	margin-bottom: 20px !important;
}

.el-notification__content {
	text-align: left !important;
}

.el-notification {
	word-break: break-word !important;
}

textarea,
input {
	font-family: "Open Sans", sans-serif !important;
	font-weight: bold;
}

.el-alert .el-alert__description {
	word-break: break-word !important;
}

.el-form--label-top .el-form-item__label {
	text-overflow: ellipsis;
	width: 270px;
	overflow: hidden;
	white-space: nowrap;
}

.el-dialog {
	border-radius: 4px !important;
}

.el-switch__label {
	font-weight: bold !important;
}

.el-alert--warning.is-light .el-alert__description,
.el-alert--warning.is-light .el-message__content,
.el-alert--warning.is-light .el-alert__icon {
	color: #210f3c !important;
}

.el-message--warning .el-alert__content,
.el-message--warning .el-message__content,
.el-message--warning .el-icon-warning {
	color: #210f3c !important;
}

.fade-in {
	-webkit-animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
	animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.vjs-tree-node {
	cursor: pointer;
}

.vjs-tree-node:after {
	content: "\2295";
	display: none;
	font-size: 25px;
	margin-left: 5px;
}

.vjs-tree-node:hover:after {
	display: block;
}

.vjs-tree-brackets {
	pointer-events: none;
}

@-webkit-keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

.el-pagination .el-select .el-input {
	width: 50px !important;
}

.el-timeline {
	padding: 0;
	margin-top: 20px !important;
}

.el-empty__image {
	width: 250px !important;
}

.el-popover {
	padding-bottom: 0px !important;
}

.ace-chrome .ace_marker-layer .ace_active-line {
	background: rgb(233, 231, 236) !important;
}

.ace-chrome .ace_gutter {
	background: #f5f7fa !important;
}

.ace-chrome .ace_gutter-active-line {
	background-color: rgb(233, 231, 236) !important;
}

.vjs-value {
	word-break: normal !important;
}

.vjs-tree {
	display: flex !important;
}

.terminal /deep/ .el-tabs__header {
	margin: 0 !important;
}
</style>
